import * as React from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    AutocompleteInput,
    TextInput,
    NumberInput,
    BooleanInput,
    useDataProvider,
} from 'react-admin';

export const AddNewDeptApprovalEntryForm = props => {
    const productionId = props.match.params.productionId;
    const dataProvider = useDataProvider();
    const [deptChoices, setDeptChoices] = React.useState([]);

    React.useEffect(() => {
        dataProvider.getOne('productions', { id: productionId })
            .then(({ data }) => {
                setDeptChoices((data.departments || []).map(d => ({ id: d.id, name: d.name })));
            });
    }, [productionId]);

    const transform = data => ({
        ...data,
        production_id: parseInt(productionId, 10),
    });

    const redirect = `/productions/${productionId}/show/dept-approvals`;
    const { staticContext, ...rest } = props;

    return (
        <Create basePath="" resource="department-approval-entries" {...rest} transform={transform}>
            <SimpleForm redirect={redirect}>
                <SelectInput source="department_id" label="Department" choices={deptChoices} />
                <ReferenceInput source="user_id" reference="users" label="User" perPage={1000}>
                    <AutocompleteInput optionText="name" />
                </ReferenceInput>
                <TextInput source="role_name" label="Role Name" />
                <NumberInput source="stage" label="Stage" defaultValue={1} inputProps={{ min: 1 }} />
                <BooleanInput source="wildcard_approval" label="Wildcard Approval" />
                <BooleanInput source="can_undo_final_approval" label="Can Undo Final Approval" />
            </SimpleForm>
        </Create>
    );
};
